import { FC } from 'react'
import Image from 'next/image'

import WidthLimiter from 'containers/width-limiter/width-limiter'
import Button from 'components/parts/button/button'
import usePCWindow from 'hooks/usePCWindow'

import { STATIC_URL } from 'constants/data'
import { ScreenSize } from 'constants/media-constanst'
import { A_LOG_REG_HASH, originRegMain } from 'utils/analytics/other/registration/registration'

import styles from './intro-bottom-block.module.scss'

const doctorImgMob = {
  src: `${STATIC_URL}/intro-alt/necessary/doctor-bottom-mob.png`,
  width: 221,
  height: 339,
  alt: 'doctor',
}

const doctorImg = {
  src: `${STATIC_URL}/intro-alt/necessary/doctor-bottom.png`,
  width: 361,
  height: 465,
  alt: 'doctor',
}

interface IIntroBottomBlock {
  showRegistrationForm: () => void
}

const IntroBottomBlock: FC<IIntroBottomBlock> = ({ showRegistrationForm }) => {
  const isDesktop = usePCWindow(ScreenSize.big)

  const btnHandler = () => {
    showRegistrationForm()
    sessionStorage.setItem(A_LOG_REG_HASH, originRegMain.COMMUNITY)
  }
  return (
    <div className={styles.wrapper}>
      <WidthLimiter noBottomPadding noLeftPadding noRightPadding noTopPadding>
        <div className={styles.helper}>
          <div className={styles.title}>MEDPOINT</div>
          <div className={styles.subtitle}>
            Профессиональное развитие и&nbsp;клиническая практика,{' '}
            <span>объединенные в одном месте</span>
          </div>
          <div className={styles.btnWrap}>
            <Button onClick={btnHandler}>Стать частью сообщества</Button>
          </div>
          {isDesktop ? (
            <Image className={styles.doctorImg} {...doctorImg} />
          ) : (
            <Image className={styles.doctorImg} {...doctorImgMob} />
          )}
          <div className={styles.circle} />
        </div>
      </WidthLimiter>
    </div>
  )
}

export default IntroBottomBlock
